export default __webpack_public_path__ + "static/media/certificate-blue-close.ed480831.svg";